import { styled } from "@mui/material/styles";
import { GridFooter } from "@mui/x-data-grid";

const Footer = styled(GridFooter)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    "& .MuiTablePagination-displayedRows": {
        fontSize: "15px",
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(0, 1),
    },
    "& .MuiTablePagination-root": {
        color: "whitesmoke"
    },
    "& .MuiSelect-select, & .MuiTablePagination-selectIcon, & .MuiDataGrid-selectedRowCount": {
        display: "none"
    }
}));

export default Footer;
